import { Color } from "../types/color";
import { light } from "./light";

export const dark:Color = light
